export async function findJavaScriptCodes(file: File): Promise<string[]> {
  const pdfContent = await readPDFFile(file)
  const jsPattern = /\/JS\s*\(([\s\S]*?)\)\s*\/S\s*\/JavaScript/g
  const javascriptCodes: string[] = []
  let match: RegExpExecArray | null

  while ((match = jsPattern.exec(pdfContent)) !== null) {
    if (match[1]) {
      javascriptCodes.push(match[1])
    }
  }

  return javascriptCodes
}

function readPDFFile(file: File): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = (error) => reject(error)
    reader.readAsText(file)
  })
}
